import InviteItem from "./invite-item";

export default InviteItem;
